var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1758,
    cy: 28.6084,
    r: 28.1084,
    stroke: "#131415"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0096 41.125H17.386V23.0152H23.0096V41.125ZM20.1944 20.5449C18.3964 20.5449 16.9375 19.0549 16.9375 17.2569C16.9375 16.3931 17.2806 15.5647 17.8914 14.9539C18.5022 14.3431 19.3306 14 20.1944 14C21.0582 14 21.8866 14.3431 22.4974 14.9539C23.1082 15.5647 23.4514 16.3931 23.4514 17.2569C23.4514 19.0549 21.9924 20.5449 20.1944 20.5449ZM44.0567 41.125H38.4457V32.3094C38.4457 30.2082 38.4031 27.5141 35.522 27.5141C32.5983 27.5141 32.1498 29.7964 32.1498 32.1582V41.125H26.532V23.0152H31.925V25.4855H32.0035C32.7543 24.0624 34.5881 22.5608 37.3239 22.5608C43.0153 22.5608 44.0615 26.3089 44.0615 31.1769V41.125H44.0567Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.27a36a50174f980d631f7fdcefbf7fbb.svg";
export { ForwardRef as ReactComponent };